import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import { CopyToClipboard } from "react-copy-to-clipboard";
import Barcode from "react-barcode"

class ALUOutboundCheatSheet2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			copied: {}
		};
	}

	handleCopy = (key) => {
		this.setState({
			copied: {
				...this.state.copied,
				[key]: true
			}
		});
		// Reset the copied state after 2 seconds
		setTimeout(() => {
			this.setState({
				copied: {
					...this.state.copied,
					[key]: false
				}
			});
		}, 2000);
	}

	render() {
		const { copied } = this.state;
		
		return (
			<div>
			{/*		<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item"><a href="#/">Home</a></li>
					<li className="breadcrumb-item"><a href="#/">Extra</a></li>
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>	
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1> */}
				<Panel>
					<PanelHeader>ALU-Outbound-Cheat-Sheet</PanelHeader>
					<PanelBody>
						<h2>
							<CopyToClipboard 
								text="RETROFIT" 
								onCopy={() => this.handleCopy('retrofit')}
							>
								<span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
									RETROFIT {copied.retrofit && <span style={{ color: 'green' }}>(Copied!)</span>}
								</span>
							</CopyToClipboard>
						</h2>
						<h2>
							<CopyToClipboard 
								text="sonner.karaca@cevalogistics.com" 
								onCopy={() => this.handleCopy('email')}
							>
								<span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
									sonner.karaca@cevalogistics.com {copied.email && <span style={{ color: 'green' }}>(Copied!)</span>}
								</span>
							</CopyToClipboard>
						</h2>
						<h2>DHL-TDI for red orders</h2>						
						<h2>DHL-DDI for blue orders</h2>												
						<h2>
							TelephoneNumber for Speedair : 
							<CopyToClipboard 
								text="+30 210 9951002" 
								onCopy={() => this.handleCopy('phone')}
							>
								<span style={{ cursor: 'pointer', textDecoration: 'underline', marginLeft: '10px' }}>
									+30 210 9951002 {copied.phone && <span style={{ color: 'green' }}>(Copied!)</span>}
								</span>
							</CopyToClipboard>
						</h2>	
						<h2>
							TelephoneNumber for Equinix (DE) : 
							<CopyToClipboard 
								text="+4969750013220" 
								onCopy={() => this.handleCopy('phone')}
							>
								<span style={{ cursor: 'pointer', textDecoration: 'underline', marginLeft: '10px' }}>
									+4969750013220 {copied.phone && <span style={{ color: 'green' }}>(Copied!)</span>}
								</span>
							</CopyToClipboard>
						</h2>	
										
						<h2>Telefonica and Orange orders</h2>						
						<p>For telefonica, set printer 03 and for Orange set printer 05 =&gt; After printing the labels, change the printer back to LOCL =&gt;
						=&gt; Start ZLAC =&gt; select delivery-nr =&gt; F8 =&gt; replace box, stick labels on the right locations on the new box
						=&gt; Start common outbound-process =&gt; start VL02N =&gt; select delivery Outbound =&gt; 
						Go to ZPA1 =&gt; =&gt; =&gt;
						</p>
						<p>Process them like common outbound, but for sending them with AWB, use OTM =&gt; Enter =&gt; printout 3X for common items. for SCRAP printout 4X =&gt;
						=&gt; Go to ZPAC =&gt; 
						After done, fill in access, select Orange /Telefonica, fill in quantity, order-nr =&gt;
						</p>
							
						<h2>OTM</h2>						
						<p>Go to Manage deliveries =&gt; for Red order fill first 0 in then the delivery-nr, for White orders only scan in delivery-Nr  
						=&gt; Enter =&gt; select OTM =&gt; click on "Actions" =&gt; Click on "Routing Options" =&gt; at "Transport Mode" select Courier =&gt;
						Click Show Options for Red order select Express, for 12:00h Red order select deliver before 12:00, for White orders select Economic
						=&gt; Click OK =&gt; Close Screen =&gt; Go back to Manage deliveries =&gt; click on + =&gt; Click on "Buy Shipment" =&gt; Click on delivery =&gt; 
						=&gt; Click on "Specific Field" =&gt; Fill phone-number of from shipment-paper in field "phone" =&gt; Click on "Finished" =&gt;
						Select OTM =&gt; click on "Actions" =&gt; Click "Secure Options" =&gt; close screen =&gt; click on Manage Result =&gt;
						click on "Buy shipment" =&gt; go to "documents" =&gt; click on "glsses"-icon =&gt; CTRL+P to printout AWB
						</p>
						<p>
							If there is error , then you can try to fill the pickingdate is today
						</p>
						<h2>OTM from scratch</h2>						
						<p>Go to Manage deliveries =&gt; for Red order fill first 0 in then the delivery-nr, for White orders only scan in delivery-Nr  
						=&gt; Enter =&gt; select OTM =&gt; click on "Actions" =&gt; Click on "Routing Options" =&gt; at "Transport Mode" select Courier =&gt;
						Click Show Options for Red order select Express, for 12:00h Red order select deliver before 12:00, for White orders select Economic
						=&gt; Click OK =&gt; Close Screen =&gt; Go back to Manage deliveries =&gt; click on + =&gt; Click on "Buy Shipment" =&gt; Click on delivery =&gt; 
						=&gt; Click on "Specific Field" =&gt; Fill phone-number of from shipment-paper in field "phone" =&gt; Click on "Finished" =&gt;
						Select OTM =&gt; click on "Actions" =&gt; Click "Secure Options" =&gt; close screen =&gt; click on Manage Result =&gt;
						click on "Buy shipment" =&gt; go to "documents" =&gt; click on "glsses"-icon =&gt; CTRL+P to printout AWB
						</p>
							
					</PanelBody>
				</Panel>
		
			</div>
		)
	}
}


export default ALUOutboundCheatSheet2;

